export interface ConsoleInit{
    messageFilterCount: number
    history: ConsoleMessage[]
}

export interface ConsoleMessage {
    timestamp: number
    content: string
    type: ConsoleMessageLogType
    plugin?: string
    originalCommand?: string
    originalRunner?: string
}

// DO NOT CHANGE ORDER !!!!
export enum ConsoleMessageLogType{
    Information,
    Warning,
    Error,
    Input,
    // Only in frontend
    // Log color depends on value so do not change!
    None = 1000,
    System = 1004
}

export interface ConsoleFilter{
    filter: string
    type: ConsoleFilterType
    ignoreCase: boolean
    enabled: boolean
}

export interface PostConsoleFilterResponse{
    ok: boolean
    errors: ConsoleFilterError[]
}

export interface ConsoleFilterError{
    index: number
    error: string
}

export interface ConsoleFilterUpdate{
    filterCount: number
}

// DO NOT CHANGE ORDER !!!!
export enum ConsoleFilterType{
    String,
    StartsWith,
    Contains,
    EndsWith,
    Regex
}

export interface Vector3{
    x: number
    y: number
    z: number
}

export interface PlayerDetails {
    steamId: string
    steamDisplayName: string
    steamAvatarHash: string
    steamAccountCreated: number
    steamAliases: string[]
    steamGameBans: number
    steamVacBans: number
    steamLastBanTime: number

    displayName: string
    firstSeen: number
    lastSeen: number
    isConnected: boolean
    ip?: string
    position?: Vector3
    teamId?: number
    sessionPlayTime: number
    totalPlayTime: number
    noteCount: number
    strikeCount: number
    isBanned: boolean

    banReason?: string
    banExpiry?: number
    banTime?: string
    banAuthor?: string

    //[key: string]: any
}

export interface PlayerLite{
    steamId: string
    displayName: string
    isConnected: boolean
}

export interface PlayerUltraLite{
    steamId: string
    displayName: string
    [key: string]: any
}

export interface PlayerTeam{
    teamId: number
    members: PlayerLite[]
}

export interface PlayerNote{
    id: string
    author: string
    content: string
    created: number
}

export interface GetPlayersResponse{
    players: PlayerDetails[]
    playerCount: number
    hasNextPage: boolean
}

export interface GetPlayerResponse{
    isMatch: boolean
    isBanned: boolean
    displayName: string
    player?: PlayerDetails
    team?: PlayerTeam
    notes: PlayerNote[]
}

export interface GetPlayerTeamResponse{
    team: PlayerTeam
}

export interface GetPlayerNotesResponse{
    notes: PlayerNote[]
}

export interface BanList{
    bans: Ban[]
    banCount: number
    hasNextPage: boolean
}

export interface Ban{
    steamId: string
    displayName?: string
    author?: string
    reason?: string
    timestamp: number
    expiry: number

    [key: string]: any
}

export interface GetStrikesResponse{
    strikes: Strike[]
}

export interface Strike{
    id: string
    created: number
    steamId: string
    author?: string
    text?: string
    type: StrikeType
}

export enum StrikeType{
    // Manually created by the user
    GENERIC,
    KICK,
    BAN
}

export interface PostStrikeResponse{
    id: string
}

export interface GetWhitelistResponse{
    enabled: boolean
    rejectReason: string
    players: PlayerLite[]
}

export interface GetAclUsersResponse{
    users: AclUser[]
}

export interface AclUser{
    isOwner: boolean
    id: string
    displayName: string
    steamId?: number
    permissions: string[]
}

export interface GetAuthResponse{
    isLoggedIn: boolean
    // When logged in
    userName?: string
    email?: string
    avatarUrl?: string
    isValidServerId: boolean
}

export interface MapInfo{
    isAvailable: boolean
    size: number
    imageId: string
    monuments: Monument[]
}

export interface Monument{
    displayName: string
    posX: number
    posZ: number
}

export interface ChatInit{
    messages: ChatMessage[]
}

export interface ChatMessage{
    serverId: string
    channel: ChatChannel
    timestamp: number
    message: string
    authorSteamId: string
    authorDisplayName: string
    authorTeamId: string
}

export enum ChatChannel
{
    GLOBAL,
    TEAM,
    SERVER,
    CARDS,
    LOCAL,
    CLAN,
    EXTERNAL_DM,

    SYSTEM = 1000
}
export interface UserSettings{
    readonly dashboardLayoutJSON?: string
    readonly compactLayout: boolean
}